/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { pluck } from '../prop-utils/prop-utils';
import digitalCoreReducer from './digital-core-reducer';

var connectDigitalCore = function connectDigitalCore() {
  return function (rootReducer) {
    return function (state, action) {
      var digitalCoreState = {};
      var pluckedState;

      if (state) {
        digitalCoreState = state['digitalCore'] || digitalCoreState;
        pluckedState = pluck(['digitalCore'], state);
      }

      var reducerResults = rootReducer(pluckedState, action);
      reducerResults['digitalCore'] = digitalCoreReducer(digitalCoreState, action);
      return reducerResults;
    };
  };
};

export default connectDigitalCore;